type Props = {
    results: any;
  };
  
  type ResultObjectKey =
    | 'resultsAddress'
    | 'countryLongName'
    | 'countryShortName'
    | 'cityLongName'
    | 'cityPostalTownLongName'
    | 'cityShortName'
    | 'postalCodeLongName'
    | 'postalCodeShortName'
    | 'streetLongName'
    | 'streetShortName'
    | 'stateLongName'
    | 'stateShortName';
  
  type ResultObject = {
    [key in ResultObjectKey]?: string;
  };
  
  type AddressComponent = {
    short_name: string;
    long_name: string;
    types: string[];
  };
  
  type LocationAttribute =
    | 'city'
    //TODO: should be removed
    | 'cityPostalTown'
    | 'state'
    | 'country'
    | 'street'
    | 'unitNumber'
    | 'postalCode';
  
  type AttributesMap = {
    [key in LocationAttribute]: string[];
  };
  export const formatAddress = ({ results }: Props) => {
    const attributesMap: AttributesMap = {
      city: ['locality', 'administrative_area_level_2'],
      //TODO: should be removed
      cityPostalTown: ['postal_town'],
      state: ['administrative_area_level_1'],
      country: ['country'],
      street: ['street_number,route'],
      postalCode: ['postal_code'],
      unitNumber: ['subpremise'],
    };
  
    const getValueFromResults = (prop: string) => {
      return results[0]?.address_components?.find(
        (component: AddressComponent) => {
          return component?.types?.includes(prop);
        },
      ) as AddressComponent;
    };
  
    const mapAddressComponentsToProps = (
      propName: string,
      ...addressComponents: AddressComponent[]
    ) =>
      propName && addressComponents && addressComponents.length > 0
        ? {
            [`${propName}LongName`]: addressComponents
              .map((item: AddressComponent) => item.long_name)
              .join(' '),
            [`${propName}ShortName`]: addressComponents
              .map((item: AddressComponent) => item.short_name)
              .join(' '),
          }
        : {};
  
    let addressInformation: ResultObject = Object.keys(attributesMap).reduce(
      (current: ResultObject, next: string) => {
        const results: ResultObject[] = attributesMap[
          next as LocationAttribute
        ].map((item: string) => {
          return mapAddressComponentsToProps(
            next,
            ...item
              .split(',')
              .map((sub: string) => {
                return getValueFromResults(sub);
              })
              .filter((sub) => sub),
          );
        });
        return {
          ...current,
          ...results.find(
            (item: ResultObject) => item[`${next}LongName` as ResultObjectKey],
          ),
        };
      },
      {},
    );
  
    addressInformation.resultsAddress = results[0]?.formatted_address;
  
    return addressInformation;
  };
  